<template>
  <transition name="app-splash" @after-leave="$emit('hidden')">
    <div v-if="visible" class="app-splash" style="background-image:linear-gradient(rgba(7,9,13,.21),rgba(7,9,13,.21)),url('/pwa/splash-world-v2.jpg')" aria-hidden="true">
      <div class="app-splash-brand">
        <img src="/pwa/splash-brand-mark.png" alt="" draggable="false">
        <strong>{{ $t("pwa.splash.headline") }}</strong>
        <small>OPEN A NEW WORLD</small>
      </div>
    </div>
  </transition>
</template>

<script>
const MIN_SPLASH_MS = 800
const MAX_SPLASH_MS = 5000

export default {
  name: "AppSplash",
  props: {
    ready: { type: Boolean, default: false }
  },
  data() {
    return {
      visible: true,
      minimumElapsed: false,
      minimumTimer: 0,
      maximumTimer: 0
    }
  },
  watch: {
    ready() { this.finishWhenReady() }
  },
  mounted() {
    const bootStarted = Number(window.__STARLIVE_BOOT_STARTED || performance.now())
    const elapsed = Math.max(0, performance.now() - bootStarted)
    this.minimumTimer = window.setTimeout(() => {
      this.minimumElapsed = true
      this.finishWhenReady()
    }, Math.max(0, MIN_SPLASH_MS - elapsed))
    this.maximumTimer = window.setTimeout(this.hide, Math.max(0, MAX_SPLASH_MS - elapsed))
  },
  beforeDestroy() {
    window.clearTimeout(this.minimumTimer)
    window.clearTimeout(this.maximumTimer)
  },
  methods: {
    finishWhenReady() {
      if (this.ready && this.minimumElapsed) this.hide()
    },
    hide() {
      if (!this.visible) return
      window.clearTimeout(this.minimumTimer)
      window.clearTimeout(this.maximumTimer)
      this.visible = false
    }
  }
}
</script>

<style scoped>
.app-splash{position:fixed;z-index:15000;inset:0;display:grid;align-content:start;justify-items:center;padding:max(24px,env(safe-area-inset-top)) max(24px,env(safe-area-inset-right)) max(24px,env(safe-area-inset-bottom)) max(24px,env(safe-area-inset-left));overflow:hidden;background-color:#07090d;background-position:center;background-size:cover;background-repeat:no-repeat;isolation:isolate}
.app-splash-brand{position:relative;display:grid;justify-items:center;gap:0;margin-top:calc(25.5vh - max(24px,env(safe-area-inset-top)));text-align:center;animation:app-splash-arrive .6s cubic-bezier(.2,.78,.22,1) both}
.app-splash img{width:clamp(76px,19vw,100px);height:clamp(76px,19vw,100px);object-fit:contain;filter:drop-shadow(0 12px 28px rgba(64,155,255,.24));-webkit-user-drag:none;-webkit-touch-callout:none;user-select:none}
.app-splash strong{margin-top:clamp(22px,3.5vh,34px);color:rgba(255,255,255,.96);font-family:"Microsoft YaHei UI","PingFang SC",sans-serif;font-size:clamp(18px,4.6vw,24px);font-weight:800;letter-spacing:.02em;text-shadow:0 3px 16px rgba(0,0,0,.48)}
.app-splash small{margin-top:clamp(10px,1.4vh,14px);color:rgba(255,255,255,.66);font-family:Georgia,"Times New Roman",serif;font-size:clamp(8px,1.7vw,10px);letter-spacing:.15em;text-shadow:0 2px 10px rgba(0,0,0,.5)}
.app-splash-enter-active,.app-splash-leave-active{transition:opacity 260ms ease}
.app-splash-enter,.app-splash-leave-to{opacity:0}
@keyframes app-splash-arrive{from{opacity:0;transform:translateY(8px) scale(.985)}}
@media(prefers-reduced-motion:reduce){.app-splash-brand{animation:none}.app-splash-enter-active,.app-splash-leave-active{transition-duration:.01ms}}
</style>
